import styles from "./Mosaic.module.scss";
import React, { useEffect, useState } from "react";
import back from "../../assets/mosaic/back.png";
import sprite from "../../assets/sprite.svg";
import { defaultCombine, mosaicApi } from "../../assets/mosaic";
import { mosaicColorBlender } from "../../helpers/mosaicColorBlender";
import { Group, Layer, Stage } from "react-konva";
import { MosaicMask } from "../../helpers/mosaicProcessor";
import useWindowSize from "../../hooks/useWindowSize";
import { getMosaicProducts } from "../../helpers/colorsGetProducts";

const defaultSize = {
  width: 300,
  height: 292,
  mosaic: {
    width: 40,
    height: 40,
  },
};

export const Mosaic = ({
  device,
  setPicker,
  mosaicCombine,
  mosaicSelected,
  setMosaicCombine,
  setMosaicSelected,
}) => {
  const [activeCombiner, setActiveCombiner] = useState();
  const [mosaicResult, setMosaicResult] = useState([]);
  const [renderResolution, setRenderResolution] = useState(defaultSize);
  const size = useWindowSize()?.width;

  function checkColorCodes() {
    for (let i = 0; i < mosaicCombine?.length; i++) {
      if (mosaicCombine[i].color?.code !== "") {
        return true;
      }
    }
    return false;
  }

  const colorsCounter =
    mosaicCombine.filter(({ color }) => color?.code !== "").length === 4;

  const mobile = device === "mobile";
  const miniTablet = device === "miniTablet";

  const MosaicSelect = () => {
    return (
      <>
        {mosaicSelected?.length > 0 && (
          <div className={styles.mosaicSelect}>
            <span>Обрані</span>
            <ul>
              {mosaicSelected.map((m) => (
                <li key={m.id}>
                  <Stage
                    width={renderResolution?.mosaic.width}
                    height={renderResolution?.mosaic.height}
                  >
                    {m.set?.map((i) => (
                      <Layer key={JSON.stringify(i.id)}>
                        <Group>
                          <MosaicMask
                            item={i}
                            renderResolution={renderResolution.mosaic}
                          />
                        </Group>
                      </Layer>
                    ))}
                  </Stage>
                  <div
                    onClick={() => onSelectedClick(m.id)}
                    className={styles.increment}
                  >
                    <span />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    const updatedMosaicCombine = mosaicCombine.map((item) => {
      const nonEmptyImages = mosaicCombine.filter((x) => x.color.img !== "");
      const emptyImages = mosaicCombine.filter((x) => x.color.img === "");

      if (
        nonEmptyImages.length === 1 &&
        emptyImages.length === mosaicCombine.length - 1
      ) {
        return {
          ...item,
          color: {
            ...item.color,
            img: nonEmptyImages[0].color.img,
          },
        };
      }

      if (nonEmptyImages.length === 2 && emptyImages.length === 2) {
        return {
          ...item,
          color: {
            ...item.color,
            img: nonEmptyImages[mosaicCombine.indexOf(item) % 2].color.img,
          },
        };
      }

      if (
        nonEmptyImages.length === 3 &&
        emptyImages.length === 1 &&
        item.color.img === ""
      ) {
        return {
          ...item,
          color: {
            ...item.color,
            img: nonEmptyImages[0].color.img,
          },
        };
      }

      return item;
    });

    setMosaicResult(updatedMosaicCombine);
  }, [mosaicCombine]);

  useEffect(() => {
    if (size >= 1400) {
      setRenderResolution({
        width: 300,
        height: 292,
        mosaic: {
          width: 41.88,
          height: 40,
        },
      });
    } else if (size >= 1200 && size < 1400) {
      setRenderResolution({
        width: 285,
        height: 292,
        mosaic: {
          width: 40,
          height: 40,
        },
      });
    } else if (size >= 992 && size < 1200) {
      setRenderResolution({
        width: 260,
        height: 160,
        mosaic: {
          width: 32,
          height: 40,
        },
      });
    } else if (size >= 768 && size < 992) {
      setRenderResolution({
        width: 195,
        height: 180,
        mosaic: {
          width: 70,
          height: 40,
        },
      });
    } else if (size < 768) {
      setRenderResolution({
        width: size - 30,
        height: 127,
        mosaic: {
          width: (size - 30) / 10 - 4.5,
          height: (size - 30) / 10 - 4.5,
        },
      });
    }
  }, [size]);

  useEffect(() => {
    setMosaicCombine(defaultCombine);
  }, []);

  const onPaletteClick = (color) => {
    const updatedMosaicCombine = mosaicCombine.map((item) => {
      if (item.id === activeCombiner?.id) {
        return {
          ...item,
          color: { ...color },
        };
      }
      return item;
    });
    setMosaicCombine(updatedMosaicCombine);
  };

  useEffect(() => {
    const color = mosaicColorBlender(mosaicCombine);
    setPicker(color);
  }, [mosaicCombine]);

  const onCombineClick = (combine) => {
    setActiveCombiner(combine);
  };

  const onSelectedClick = (code) => {
    if (code) {
      setMosaicSelected(mosaicSelected?.filter((item) => item.id !== code));
    } else {
      const isResultAlreadySelected = mosaicSelected.some((item) => {
        return JSON.stringify(item.set) === JSON.stringify(mosaicResult);
      });
      if (isResultAlreadySelected) {
        return;
      }

      getMosaicProducts(mosaicResult)
        .then((resp) => {
          if (resp.length === 0) {
            return;
          }
          const { _id, product, primer } = resp[0];
          const newMosaicItem = {
            id: _id,
            set: mosaicResult,
            product,
            primer,
          };
          setMosaicSelected([...mosaicSelected, newMosaicItem]);
        })
        .catch(() => console.log("No data"));
    }
  };

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          {checkColorCodes() && (
            <>
              {!(mobile || miniTablet) && <h2>Результати змішування</h2>}
              <div className={styles.activeColor}>
                <Stage
                  width={renderResolution?.width}
                  height={renderResolution?.height}
                >
                  {mosaicResult?.map((i) => (
                    <Layer key={JSON.stringify(i.id)}>
                      <Group>
                        <MosaicMask
                          item={i}
                          renderResolution={renderResolution}
                        />
                      </Group>
                    </Layer>
                  ))}
                </Stage>
                {colorsCounter && (
                  <button onClick={() => onSelectedClick()}>
                    Додати до обраних
                  </button>
                )}
              </div>
              {mobile && <MosaicSelect />}
            </>
          )}
        </div>
        <div className={styles.right}>
          <div>
            <h2>
              Оберіть колір наповнювачів (потрібно обрати всі 4-ри кольори)
            </h2>
            <ul className={styles.topSelect}>
              {mosaicCombine.map((combine) => (
                <li
                  key={combine.id}
                  onClick={() => onCombineClick(combine)}
                  style={
                    activeCombiner?.id === combine.id
                      ? { outline: "1px solid black" }
                      : undefined
                  }
                >
                  {combine.color.code === "" && (
                    <div>
                      <svg>
                        <use href={sprite + "#icon-plus"} />
                      </svg>
                    </div>
                  )}
                  <img
                    src={combine.color.code === "" ? back : combine.color.img}
                    alt={"mosaic layer"}
                  />
                </li>
              ))}
            </ul>

            {/*{activeCombiner && (*/}
            <ul className={styles.mosaicPalette}>
              {mosaicApi?.map((m) => (
                <li key={m.id} onClick={() => onPaletteClick(m)}>
                  <img src={m.img} alt={m.code} />
                </li>
              ))}
            </ul>
            {/*)}*/}
          </div>
          {!mobile && <MosaicSelect />}
        </div>
      </div>
    </>
  );
};
